/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { QuestionnaireApplicableRulesDto } from '../../models/questionnaire-applicable-rules-dto';
import { ValidateAnswerDto } from '../../models/validate-answer-dto';

export interface QuestionnaireValidateAnswer$Json$Params {
      body?: ValidateAnswerDto
}

export function questionnaireValidateAnswer$Json(http: HttpClient, rootUrl: string, params?: QuestionnaireValidateAnswer$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<QuestionnaireApplicableRulesDto>> {
  const rb = new RequestBuilder(rootUrl, questionnaireValidateAnswer$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<QuestionnaireApplicableRulesDto>;
    })
  );
}

questionnaireValidateAnswer$Json.PATH = '/v1/Questionnaire/ValidateAnswer';
